
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { NotificationMixin } from '../mixins';

@Component
export default class ServiceLevelAndPricing extends Mixins(NotificationMixin, ResponsivenessMixin) {
  private formData = {
    isDeliveryTimeInfo: {
      show: true,
      name: 'DeliveryTimeInfo',
    },
    isShowCheaperOption: {
      show: true,
      name: 'Cheaper',
    },
    isPriceChange: {
      show: true,
      name: 'CurrencyPriceChange',
    },
  }

  get isTablet(): boolean {
    return this.$vuetify.breakpoint.lgAndDown;
  }

  @Watch('isNotificationPrefs', { immediate: true })
  private populatePreferences(newValue: boolean) {
    if (newValue) {
      this.formData.isDeliveryTimeInfo.show = this.searchNotificationPref(
        this.formData.isDeliveryTimeInfo.name,
      );
      this.formData.isShowCheaperOption.show = this.searchNotificationPref(
        this.formData.isShowCheaperOption.name,
      );
      this.formData.isPriceChange.show = this.searchNotificationPref(
        this.formData.isPriceChange.name,
      );
    }
  }
}
